// @flow

import React from 'react';

import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import Input from '../../../../base/ui/components/web/Input';
import AbstractStreamKeyForm, {
    type Props, _mapStateToProps
} from '../AbstractStreamKeyForm';
import { getBaseConfig, getStore } from '../../../../customise/Utils';
import { ct } from '../../../../customise/constant-Utils';
import { FEATURE_CUSTOM_REDUX_V3 } from '../../../../customise/constant';

/**
 * A React Component for entering a key for starting a YouTube live stream.
 *
 * @augments Component
 */
class StreamKeyForm extends AbstractStreamKeyForm<Props> {

    /**
     * Initializes a new {@code StreamKeyForm} instance.
     *
     * @param {Props} props - The React {@code Component} props to initialize
     * the new {@code StreamKeyForm} instance with.
     */
    constructor(props: Props) {
        super(props);

        // Bind event handlers so they are only bound once per instance.
        this._onOpenHelp = this._onOpenHelp.bind(this);
        this._onOpenHelpKeyPress = this._onOpenHelpKeyPress.bind(this);

        // CUSTOM
        this.state = {
            streamKeys : {}
        };

        // END
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t, value } = this.props;
        const streamingPlatforms = getBaseConfig("streamingPlatforms");
        const {isChinaRegion} = getStore(FEATURE_CUSTOM_REDUX_V3);

        return (
            <div className = 'stream-key-form pt-2'>
                
                 
                {/* CUSTOM */}
                {/* New Form */}
                {
                    getBaseConfig('multiStream') ?
                    streamingPlatforms.map((item, index) => {
                        if((item == 'youtube' || item == 'facebook')) {
                            if (!isChinaRegion) {
                                return <div className="streaming-option mb-4">
                                    <label for={item} >
                                        <img src={`/images/logo/${item}.png`} />
                                        {ct("rta-trmc.liveStream." + item)}
                                    </label>
                                    <input
                                    id={item}
                                    name = {item +'StreamId'}
                                    onChange = { this._onInputChangeHandler }
                                    placeholder = { ct("rta-trmc.liveStream.enterYour") + ' ' + item + ' ' + ct("rta-trmc.liveStream.liveStreamKey") }
                                    type = 'text'
                                    value = { this.state.streamKeys[item + 'StreamId'] } /> 
                                </div>
                            }
                        } else {
                            return <div className="streaming-option mb-4">
                                <label for={item} >
                                    <img src={`/images/logo/${item}.png`} />
                                    {ct("rta-trmc.liveStream." + item)}
                                </label>
                                <input
                                id={item}
                                name = {item +'StreamId'}
                                onChange = { this._onInputChangeHandler }
                                placeholder = { ct("rta-trmc.liveStream.enterYour") + ' ' + item + ' ' + ct("rta-trmc.liveStream.liveStreamKey") }
                                type = 'text'
                                value = { this.state.streamKeys[item + 'StreamId'] } /> 
                            </div> 
                        }
                    }) 
                    /* {getBaseConfig("streamingPlatforms").includes("youtube") && 
                            <div className="streaming-option mb-4">
                                <label>YouTube</label>
                                <input
                                autoFocus = { true }
                                name = 'youtubeStreamId'
                                onChange = { this._onInputChangeHandler }
                                placeholder = { t('liveStreaming.enterStreamKey') }
                                type = 'text'
                                value = { this.state.streamKeys.youtubeStreamId } /> 
                            </div> 
                        }
                        {getBaseConfig("streamingPlatforms").includes("tiktok") && 
                            <div className="streaming-option mb-4">
                                <label>TikTok</label>
                                <input
                                name = 'tiktokStreamId'
                                onChange = { this._onInputChangeHandler }
                                placeholder = { 'Enter your TikTok live stream key here.' }
                                type = 'text'
                                value = { this.state.streamKeys.tiktokStreamId } /> 
                            </div> 
                        } 
                        {getBaseConfig("streamingPlatforms").includes("facebook") && 
                            <div className="streaming-option mb-4">
                                <label>Facebook</label> 
                                <input
                                name = 'facebookStreamId'
                                onChange = { this._onInputChangeHandler }
                                placeholder = { 'Enter your Facebook live stream key here.' }
                                type = 'text'
                                value = { this.state.streamKeys.facebookStreamId } /> 
                            </div>
                        } 
                    */
                    : <>
                    {/* Old Form */}
                    <Input
                    autoFocus = { true }
                    label = { t('dialog.streamKey') }
                    name = 'streamId'
                    onChange = { this._onInputChange }
                    placeholder = { t('liveStreaming.enterStreamKey') }
                    type = 'text'
                    value = { value } />
                    <div className = 'form-footer'>
                        <div className = 'help-container'>
                            {
                                this.state.showValidationError
                                    ? <span className = 'warning-text'>
                                        { t('liveStreaming.invalidStreamKey') }
                                    </span>
                                    : null
                            }
                            { this.props._liveStreaming.helpURL
                                ? <a
                                    aria-label = { t('liveStreaming.streamIdHelp') }
                                    className = 'helper-link'
                                    onClick = { this._onOpenHelp }
                                    onKeyPress = { this._onOpenHelpKeyPress }
                                    role = 'link'
                                    tabIndex = { 0 }>
                                    { t('liveStreaming.streamIdHelp') }
                                </a>
                                : null
                            }
                        </div>
                        <a
                            className = 'helper-link'
                            href = { this.props._liveStreaming.termsURL }
                            rel = 'noopener noreferrer'
                            target = '_blank'>
                            { t('liveStreaming.youtubeTerms') }
                        </a>
                        <a
                            className = 'helper-link'
                            href = { this.props._liveStreaming.dataPrivacyURL }
                            rel = 'noopener noreferrer'
                            target = '_blank'>
                            { t('liveStreaming.googlePrivacyPolicy') }
                        </a>
                    </div>
                    </>
                }
                
                {/* END */}
            </div>
        );
    }

    _onInputChange: Object => void;

    // CUSTOM
    _onInputChangeHandler = (e) => {
        let streamKeyObj = this.state.streamKeys;
        streamKeyObj[e.target.name] = e.target.value.trim();
        this.setState({
            streamKeys : streamKeyObj,
        })
        if (e.target.value.trim() == '') {
            delete streamKeyObj[e.target.name];
        }

        console.log('streamKeyObj',streamKeyObj)

        if (Object.keys(streamKeyObj).length) {
            this._onInputChange(JSON.stringify(streamKeyObj));
        } else {
            this._onInputChange('');
        }
    }
    // END
        

    _onOpenHelp: () => void;

    /**
     * Opens a new tab with information on how to manually locate a YouTube
     * broadcast stream key.
     *
     * @private
     * @returns {void}
     */
    _onOpenHelp() {
        window.open(this.props._liveStreaming.helpURL, '_blank', 'noopener');
    }

    _onOpenHelpKeyPress: () => void;

    /**
     * Opens a new tab with information on how to manually locate a YouTube
     * broadcast stream key.
     *
     * @param {Object} e - The key event to handle.
     *
     * @private
     * @returns {void}
     */
    _onOpenHelpKeyPress(e) {
        if (e.key === ' ') {
            e.preventDefault();
            this._onOpenHelp();
        }
    }
}

export default translate(connect(_mapStateToProps)(StreamKeyForm));
